module.exports = __webpack_public_path__ + "img/usa-flag.af6c4eba.png";